
const CellLeadCustomerDetail:React.FC<{ data: any }> = ({ data }) => {
    return (
        <>{data['lead_cust_first_name'] + ' ' + data['lead_cust_last_name']}<br /><small>{data['lead_cust_mobile_number']}</small></>       
    )
}

export default CellLeadCustomerDetail;